import alertModal2TemplateUrl from './embeddedAlertModalComponent.html';

export const embeddedAlertModalComponent = {
    controller: [
        '$scope',
        'v2DetectorResolverUtil',
        function ($scope, v2DetectorResolverUtil) {
            const $ctrl = this;

            this.$onInit = () => {
                if ($ctrl.event) {
                    $ctrl.templateUrl = alertModal2TemplateUrl;

                    v2DetectorResolverUtil
                        .extendV2DetectorBasedEvent($ctrl.event)
                        .then((extendedEvent) => {
                            $scope.event = extendedEvent;
                            $scope.onAssociationDataLoaded = $ctrl.onAssociationDataLoaded;
                            $scope.onMetricsDataLoaded = $ctrl.onMetricsDataLoaded;
                            $ctrl.initialized = true;
                        });
                }
            };
        },
    ],
    template:
        '<ng-container ng-if="$ctrl.initialized" ng-controller="alertEventModalV2">' +
        '<div class="sf-ui embedded-alert-modal" ng-class="$ctrl.colorScheme">' +
        '<div ng-include="$ctrl.templateUrl"></div>' +
        '</div>' +
        '</ng-container>',
    bindings: {
        event: '<',
        colorScheme: '=',
        onAssociationDataLoaded: '<',
        onMetricsDataLoaded: '<',
    },
};
